import { Modal } from 'antd';
import React, { useContext } from 'react';
import { LanguageContext } from '../../../shared/contexts/Language.context';
import Loader from '../../../shared/loaders/Loader';
import CustomButton from '../../CustomButton/CustomButton';
import AliceOnboarding from './AliceOnboarding';
import CivitfunOnboarding from './CivitfunOnboarding';
import useDocumentCaptureHook from './DocumentCapture.hook';
import { ThemeContext } from '../../../shared/contexts/Theme.context';

export default function DocumentCapture({ currentValues, aliceSuccessAction }) {
  const {
    state: { literals, selectedLanguage },
  } = useContext(LanguageContext);
  const { state: { ocrVersion } } = useContext(ThemeContext);

  const { state, actions } = useDocumentCaptureHook();

  var width = '100%';
  var mq = window.matchMedia('(min-width: 1024px)');
  if (mq.matches) {
    width = '80vw';
  } else {
    width = '100%';
  }

  return (
    <div>
      <Modal
        title={literals['guestForm.takePhoto']}
        visible={state.visible}
        onOk={() => actions.setVisible(false)}
        onCancel={() => actions.onCancelModal()}
        width={width}
        footer={null}
        closable={false}
        destroyOnClose={true}
        maskClosable={false}
      >
        <div
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            display: 'grid',
          }}
        >
          {state.loadUserData && <Loader></Loader>}
          {ocrVersion === 'civitfun' ? 
            <CivitfunOnboarding
              visible={state.visible}
              setVisible={actions.setVisible}
              nationality={currentValues.nationality}
              documentType={currentValues.driving_license_state ?? currentValues.document_type}
              selectedLanguage={selectedLanguage}
              literals={literals}
              aliceSuccessAction={aliceSuccessAction}
              setLoadUserData={actions.setLoadUserData}
            /> : 
            <AliceOnboarding
              visible={state.visible}
              setVisible={actions.setVisible}
              nationality={currentValues.nationality}
              documentType={currentValues.driving_license_state ?? currentValues.document_type}
              selectedLanguage={selectedLanguage}
              literals={literals}
              aliceSuccessAction={aliceSuccessAction}
              setLoadUserData={actions.setLoadUserData}
            />}
          
        </div>
      </Modal>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginLeft: '-8%' }}>
        <CustomButton
          text={literals['guestForm.takePhoto']}
          type="text"
          onClick={() => actions.setVisible(true)}
          small
        />
      </div>
    </div>
  );
}
